import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BuyScreen } from './BuyScreen';
import { SellScreen } from './SellScreen';

/**
 * Buying and cashing out, behind one pair of tabs.
 *
 * The two halves share nothing but this switch: buying goes through the B2B
 * on-ramp with its own phone and passport checks, cashing out through the
 * payouts API with its own verification. Keeping them as separate screens means
 * neither can break the other — only which one is on screen lives here.
 */
export function BuySellScreen() {
  const { t } = useTranslation();
  const [tab, setTab] = useState<'buy' | 'sell'>('buy');

  return (
    <div className="flex min-h-screen flex-col bg-surface">
      <div className="px-4 pt-4">
        <div className="flex rounded-full bg-card p-1">
          {(['buy', 'sell'] as const).map((k) => (
            <button
              key={k}
              onClick={() => setTab(k)}
              className={`h-[40px] flex-1 rounded-full text-[15px] font-medium transition-colors ${
                tab === k ? 'bg-accent text-white' : 'text-muted'
              }`}
            >
              {t(k === 'buy' ? 'buy.tab' : 'sell.tab')}
            </button>
          ))}
        </div>
      </div>

      {tab === 'buy' ? <BuyScreen /> : <SellScreen />}
    </div>
  );
}
